import React from "react";

const Loader = () => {
  return (
    <div className="background-2 loader loader-border is-active" data-text="">
      <div className="login-logo">
        <a href="index.html">
          <img
            src="/dist/img/primlogo.png"
            alt="logo"
            style={{
              width: "auto",
              height: "65px",
              animation: "beat .85s infinite",
            }}
          ></img>
        </a>
      </div>
    </div>
  );
};

export default Loader;
